import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {InputGroup, FormControl, Button, Grid, Row, Label} from 'react-bootstrap';
import './../../editor/root-entry/RootEntry.css';
import {saveEntryForm, setPolyForm} from './EntryActions';
import {LexemeUtilities} from "../LexemeHelper";
import {SCSubmitButton} from "../../../../dict-components/components";


export class EntryEditForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newForms: []
        };

        this._handleFormChange = this._handleFormChange.bind(this);
        this._handleKeyUp = this._handleKeyUp.bind(this);
        this._handleKeyUp = this._handleKeyUp.bind(this);
        this._handleSaveForm = this._handleSaveForm.bind(this);
    }

    componentWillMount() {
        const newForms = this.props.item.lexeme_data.all_forms.map((itemForm) => {
            return {id: itemForm.id, value: itemForm.form};
        })
        this.setState({newForms})
    }

    componentDidMount() {
        setTimeout(() => {
            ReactDOM.findDOMNode(this['entryForm0']).focus();
        }, 200);
    }

    _handleFormChange(item, evt) {
        var update = {...this.state};
        var itemForm = update.newForms.find(function (form) {
            return form.id === item.id;
        });
        if (itemForm) {
            itemForm.value = evt.target.value;
        }
        this.setState(update);
    }

    _handleKeyUp(evt) {
        LexemeUtilities.handleKeyUp(evt, () => {
            saveEntryForm(this.state.newForms)
        });
    }

    _handleSaveForm() {
        if(!this._hasDuplicateValues()) {
            saveEntryForm(Dict.encodeUrl(JSON.stringify(this.state.newForms)));
        } else {
            LexemeUtilities.showModalMessage("error", 'ignore:' + Dict.t('FOUND_DUPLICATE_FORMS'), 2000);
        }
    }

    _hasDuplicateValues() {
        const seen = new Set();
        for (const item of this.state.newForms) {
            if (seen.has(item.value)) {
                return true;
            }
            seen.add(item.value);
        }
        return false;
    }

    render() {

        const editForms = this.state.newForms.map((itemForm, index) => {
            return <Row style={{marginBottom: '3px'}}>
                <InputGroup id={"loc-var-edit-group"}>
                    <FormControl type="text" placeholder={Dict.t('FORM') + "..."}
                                 ref={(input) => {
                                     this['entryForm' + index] = input;
                                 }}
                                 value={itemForm.value}
                                 onChange={(evt) => this._handleFormChange(itemForm, evt)}
                                 onKeyUp={this._handleKeyUp}/>
                </InputGroup>
            </Row>
        });

        return <Grid fluid>
            {editForms}
            <Row style={{textAlign: 'right', marginTop: '10px'}}><SCSubmitButton onClick={this._handleSaveForm}
                                                                                 text={Dict.t('SAVE')}/></Row>
        </Grid>;
    }
}